import { IntegrationEnvironment } from "./ServerEndpoints";

export type KsefWebUrls = {
  [key in IntegrationEnvironment]: string;
};

export const PROCESSING_RENDER_TIME = "renderTime";

export const ksefWebUrls: KsefWebUrls = {
  Prod: "https://ap.ksef.mf.gov.pl/web/login",
  Demo: "https://ap-demo.ksef.mf.gov.pl/web/login",
  Test: "https://ap-test.ksef.mf.gov.pl/web/login",
};
